import React, { useState } from "react";
import { absMediaUrl } from "../../utils/mediaUrl";
import type { AdminFanRow } from "../../types/admin";
import { initials } from "./format";

// A fan's photo, or their initials on a colour picked from their id (the
// same fan always gets the same one). A fan with no name yet reads "—" on
// grey; a photo that fails to load falls back to the initials.
const COLOURS = ["#8b5cf6", "#f59e0b", "#3b82f6", "#10b981", "#ef4444", "#ec4899"];

export default function FanFace({ fan, size = "sm" }: { fan: Pick<AdminFanRow, "_id" | "name" | "avatarUrl">; size?: "sm" | "lg" }) {
  const [broken, setBroken] = useState(false);
  const src = absMediaUrl(fan.avatarUrl);
  const cls = `adm-fans-face adm-fans-face-${size}`;
  if (src && !broken) return <img src={src} className={cls} alt="" onError={() => setBroken(true)} />;
  const background = fan.name?.trim() ? COLOURS[(parseInt(fan._id.slice(-2), 16) || 0) % COLOURS.length] : "#9ca3af";
  return (
    <span className={cls} style={{ background }} aria-hidden="true">
      {initials(fan.name)}
    </span>
  );
}
